import { useStore } from '../app/store';
import { OVERLAYS } from './registry';

export function Overlays() {
  const S = useStore();
  if (!S.overlay) return null;
  const O = OVERLAYS[S.overlay.name];
  if (!O) return null;
  // Keyed by name + params so re-opening (e.g. "Add another enquiry") starts from a fresh form.
  return <O key={S.overlay.name + JSON.stringify(S.overlay.params) + S.overlaySeq} {...S.overlay.params} />;
}
